import type { StudentLessonRoutes } from 'ulanano-cms-api/routes/student-lessons'
import { createGranularTreaty } from '../api-factory'

export const studentLessonsApi = createGranularTreaty<StudentLessonRoutes>({ withCookies: true })
